import { render } from "./UnlinkEventoOrcamentoModal.vue?vue&type=template&id=26bf5f40"
import script from "./UnlinkEventoOrcamentoModal.vue?vue&type=script&lang=js"
export * from "./UnlinkEventoOrcamentoModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__